import { BaseStoreProps, createAdvancedStore } from "@/stores/createAdvancedStore";
import { PaymentSystemStore } from "../../../domain/store";
import { TiptopApi } from "./types";

//

interface TiptopStoreProps extends BaseStoreProps {
  tiptop: TiptopApi;
}

//

export const tiptopCommonStore: PaymentSystemStore = createAdvancedStore("TiptopCommonStore");
export const useTiptopCommonStore = tiptopCommonStore.useContext;

export const tiptopStore = createAdvancedStore<TiptopStoreProps>("TiptopStore");
export const useTiptopStore = tiptopStore.useContext;
